import { PaginatedRequest } from 'renderer/shared/schemas/common.schemas';
import { z } from 'zod';

export const WebhookSchema = z.object({
  _id: z.string(),
  userId: z.string().optional().nullable(), // Allow null and optional
  // kind: z.string(),
  data: z.record(z.string(), z.unknown()),
  // timestamp: z.string(),
  // subject: z.string(),
  type: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type GetWebhookDetailResponse = z.infer<typeof WebhookSchema>;
export type GetWebhookDetailRequest = string;

// List
export const ListWebhooksResponseSchema = z.object({
  docs: WebhookSchema.array(),
  totalDocs: z.number(),
});

export type ListWebhooksResponse = z.infer<typeof ListWebhooksResponseSchema>;

export type ListWebhooksRequest = PaginatedRequest;
